export default function Configure($stateProvider) {
    $stateProvider.state('societes-proprietaire', {
        parent: 'common',
        url: '/societes-proprietaire',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.FONCIER" | translate }}'
        }
    });

    $stateProvider.state('societes-proprietaire.list', {
        url: '/list',
        template: '<societes></societes>',
        rights: { domain: 'societesREMOVE', right: 'read', application: 'qse' },
        params: {
            genre: '64'
        },
        ncyBreadcrumb: {
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETES_PROPRIETAIRE_LIST" | translate}}'
        },
        navigation: {
            menu: 'foncier_no_category',
            translate: 'SOCIETES.BREADCRUMBS.SOCIETES_PROPRIETAIRE_LIST',
            order: 1
        },
        search: 'SOCIETES.BREADCRUMBS.SOCIETES_PROPRIETAIRE_LIST'
    });

    $stateProvider.state('societes-proprietaire.niveaux', {
        url: '/niveaux',
        template: '<societe-config-niveaux></societe-config-niveaux>',
        rights: { domain: 'nivh', right: 'read' },
        params: {
            genre: '64'
        },
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher societes > niveaux
            parent: 'societes-proprietaire.list({genre: "64"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_NIVEAUX" | translate }}'
        }
    });

    $stateProvider.state('societes-proprietaire.list.detail', {
        url: '/{id}',
        template: '<societe-detail></societe-detail>',
        rights: { domain: 'societes', right: 'read' },
        params: {
            genre: '64'
        },
        ncyBreadcrumb: {
            parent: 'societes-proprietaire.list({genre: "64"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('societes-proprietaire.new', {
        url: '/new',
        template: '<societe-form></societe-form>',
        rights: { domain: 'societes', right: 'create' },
        params: {
            genre: '64'
        },
        ncyBreadcrumb: {
            parent: 'societes-proprietaire.list({genre: "64"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_PROPRIETAIRE_NEW" | translate}}'
        },
        search: 'SOCIETES.BREADCRUMBS.SOCIETE_PROPRIETAIRE_NEW'
    });

    $stateProvider.state('societes-proprietaire.edit', {
        url: '/{id}/edit',
        template: '<societe-form></societe-form>',
        rights: { domain: 'societes', right: 'update' },
        params: {
            genre: '64'
        },
        ncyBreadcrumb: {
            parent: 'societes-proprietaire.list({genre: "64"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_PROPRIETAIRE_EDIT" | translate }}'
        }
    });

    $stateProvider.state('societes-proprietaire.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: {
            parentState: 'societes-proprietaire.new',
            genre: '64'
        },
        ncyBreadcrumb: {
            parent: 'societes-proprietaire.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });
}

Configure.$inject = ['$stateProvider'];
